
/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class TemplateActionService {
  onCreateNewFieldSet: EventEmitter<void> = new EventEmitter();
  onSearchFieldSet: EventEmitter<string> = new EventEmitter();

  onCreateNewTemplate: EventEmitter<void> = new EventEmitter();
  onSearchTemplate: EventEmitter<string> = new EventEmitter();

  onAddFieldsetField: EventEmitter<void> = new EventEmitter();
  onSearchFieldsetField: EventEmitter<string> = new EventEmitter();

  onAddTemplateValue: EventEmitter<void> = new EventEmitter();
  onSearchTemplateValue: EventEmitter<string> = new EventEmitter();

  onEditTemplateValue: EventEmitter<any> = new EventEmitter();
}
